import axios from 'axios';
import user from '../utils/user';

export default {
  async getAcquirers(paymentTypeId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-methods/${paymentTypeId}/acquirers`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async updateAcquirers(paymentTypeId, acquirers) {
    try {
      const response = await axios.put(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-methods/${paymentTypeId}/acquirers`,
        { acquirers },
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async getAcquirerLogs(acquirerId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/payment-methods/acquirers/${acquirerId}/logs`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
